import l, { type LoadableComponent } from "@loadable/component";
import type { LoginPageProps } from "./login";

export const Login: LoadableComponent<LoginPageProps> = l(() => import("./login"));

export const Signup: LoadableComponent<{
}> = l(() => import("./signup"));

export const Dashboard: LoadableComponent<{
}> = l(() => import("./dashboard"));
